import { useState } from 'react';
import { useDidMount, useWillUnmount } from 'rooks';

import Error from '@/components/common/Error';
import Loader from '@/components/common/Loader';

import { useDocumentPreview } from '@/data/document';

const DocumentPreview = ({ document }) => {
  const previewDocument = useDocumentPreview();
  const [apiError, setApiError] = useState('');
  const [isDownloading, setIsDownloading] = useState(true);
  const [url, setUrl] = useState(null);

  useDidMount(async () => {
    try {
      const url = await previewDocument(document);
      setUrl(url);
    } catch (error) {
      setApiError(error.message);
    } finally {
      setIsDownloading(false);
    }
  });

  useWillUnmount(() => {
    if (url) {
      window.URL.revokeObjectURL(url);
    }
  });

  const handleLoad = () => {
    setIsDownloading(false);
  };

  return (
    <div>
      {isDownloading && (
        <div className="h-screen max-h-[80vh] flex items-center justify-center">
          <Loader />
        </div>
      )}
      {url && (
        <iframe
          src={url}
          className="w-full h-screen max-h-[80vh]"
          onLoad={handleLoad}
        />
      )}
      {apiError && <Error error={apiError} />}
    </div>
  );
};

export default DocumentPreview;
